/**
 * O que todo conteúdo flutuante (menu, seletor que abre por cima) precisa para
 * acompanhar o tamanho das letras.
 *
 * O A−/A+ da barra aplica `zoom: var(--escala)` no `<main>`. Um menu do Radix é
 * desenhado num `Portal`, direto no `<body>` — fora do `<main>` —, e ficava
 * sempre em 100%: quem aumentou a letra para conseguir ler abria um menu e
 * voltava à letra miúda.
 *
 * **O zoom vai no `Menu.Content`, não no invólucro.** O Radix posiciona o
 * invólucro (`[data-radix-popper-content-wrapper]`) com `transform`; pôr o zoom
 * nele multiplicaria o deslocamento e o menu abriria longe do botão. No filho,
 * cresce só o que está dentro.
 */

import type { CSSProperties } from "react"

export const escalaFlutuante: CSSProperties = { zoom: "var(--escala, 1)" }

/**
 * Altura máxima que respeita o espaço até a borda da janela **e** a escala.
 *
 * O Radix publica o espaço livre em px de tela; dentro de um elemento com zoom,
 * cada px de CSS vira `escala` px de tela. Dividir pela escala é o que faz o
 * menu grande continuar cabendo e rolar, em vez de vazar pela borda.
 */
export function alturaMaximaFlutuante(teto: number): string {
  return `min(calc(var(--radix-dropdown-menu-content-available-height) / var(--escala, 1)), ${teto}px)`
}

/**
 * Uma fração da altura da janela, para quem está DENTRO do `<main>` com zoom — os
 * modais das telas.
 *
 * Lá dentro o zoom multiplica até o `vh`: um modal com `max-height: 92vh` em 130%
 * ocupava 120% da janela, e o fim dele (o botão de gravar) ficava fora da tela, sem
 * rolagem que alcançasse. Dividir pela escala devolve o valor à janela de verdade.
 */
export function alturaDaJanela(vh: number): string {
  return `calc(${vh}vh / var(--escala, 1))`
}
